module.exports = __webpack_public_path__ + "static/media/205-Pflegemassnahmen_ID_1.9ce4e14b.mp3";